module.exports = __webpack_public_path__ + "img/monitoring.8564cec1.svg";